import { TextManager } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { RadioButtonOption } from ".";
import { Option } from "./RadioButtonTrueFalse";

export const getYesOrNoOptions = (idYes: string, idNo: string): Option[] => {
  return [
    {
      id: idYes,
      value: true,
      label: TextManager.getText(OptionLabel.BOOLEAN_YES),
    },
    {
      id: idNo,
      value: false,
      label: TextManager.getText(OptionLabel.BOOLEAN_NO),
    },
  ];
};

export const getOptions = (field: any, lang: string): RadioButtonOption[] =>
  field.options.map((option: RadioButtonOption) => {
    return {
      id: option.id ?? option.value,
      label: option.label[lang],
      value: option.value,
      hint: option.hint ? option.hint[lang] : "",
    };
  });
